import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { Share, Email, LocationOn, Hub, Instagram } from "@mui/icons-material";

const Footer = () => {
  return (
    <footer className="sgpgi-footer">
      <div className="footer-container">
        {/* Brand Info */}
        <div className="footer-col brand-col">
          <div className="footer-logo-row">
            <img src="/logo.png" alt="SGPGI Logo" className="footer-logo-img" />
            <div className="footer-logo-text-group">
              <span className="footer-logo-title">SGPGI</span>
              <span className="footer-logo-subtitle">Pediatric Surgical Superspecialties</span>
            </div>
          </div>

          <p className="footer-desc">
            Sanjay Gandhi Postgraduate Institute of Medical Sciences. A premier medical research and tertiary healthcare
            institution.
          </p>
          <div className="footer-social-media">
            <div className="footer-social-icons">
              {/* <Link to="/e" target="_blank" rel="noopener noreferrer" className="footer-social-link">
                <Instagram />
              </Link> */}
            </div>
          </div>
        </div>

        {/* Department */}
        <div className="footer-col">
          <h4 className="footer-heading">DEPARTMENT</h4>
          <ul className="footer-links-list">
            {/* <li>
              <Link to="/events">Events</Link>
            </li> */}
            {/* <li>
              <Link to="/cases">Case Repository</Link>
            </li>
            <li>
              <Link to="/notices">Notices</Link>
            </li>
            <li>
              <Link to="/photo-gallery">Photo Gallery</Link>
            </li> */}
          </ul>
        </div>

        {/*  Support  */}
        <div className="footer-col">
          <h4 className="footer-heading">SUPPORT</h4>
          <ul className="footer-links-list">
            {/* <li>
              <Link to="/contact">Contact Us</Link>
            </li> */}
            {/* <li>
              <Link to="/about#mission-vision">Mission & Vision</Link>
            </li>
            <li>
              <Link to="/registration-form">Patient Portal</Link>
            </li> */}
          </ul>
        </div>

        <div className="map-card">
          <iframe
            title="SGPGI Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14251.022520460248!2d80.93565094606592!3d26.752173238903428!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfb064de846b9%3A0xc8f7227d966659bc!2sSGPGI%2C%20Lucknow%2C%20Uttar%20Pradesh%20226014!5e0!3m2!1sen!2sin!4v1769681614974!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>

      {/*Footer Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-container bottom-container">
          <p className="copyright-text">
            © 2026 Sanjay Gandhi Postgraduate Institute of Medical Sciences. All Rights Reserved.
          </p>
          {/* <div className="bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
          </div> */}
          <p>
            Powered by{" "}
            <a href="https://www.techbrj.com/" target="_blank" rel="noreferrer" className="footer-dev-link">
              TechBRJ
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
